/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';
import NavigationService from 'services/NavigationService';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
@inject('costCenterDetailsStore')
@observer
export default class AssignedToCostCenter extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;
    const details: any = this.props.details;

    const isLinkDisabled: Function = (len: number) =>
      `${'layout-button' + (len === 0 ? ' disabled' : '')}`;

    return (
      <React.Fragment>
        <h3>{t('general:cost_centers.currently_assigned_to')}</h3>
        <table className="layout-table large-first-col">
          <tbody>
            <tr>
              <td style={{ width: '130px' }}>
                <b>{t('general:project_plural')}</b>
              </td>
              <td className="layout-flex">
                <div>
                  <span>{details.projects_count}</span>
                  <Link
                    to={NavigationService.formulateReportViewUri('/projects', {
                      page: 1,
                      filters: [{ key: 'cost_centre', values: [details.id] }],
                    })}
                    className={isLinkDisabled(details.projects_count)}
                  >
                    <Button variant="contained" color="primary" disabled={!details.projects_count}>
                      {t('general:actions.view_project', {
                        count: details.projects_count,
                      })}
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.all')}</b>
              </td>
              <td className="layout-flex">
                <div>
                  <span>{details.assets.all}</span>
                  <Link
                    to={NavigationService.formulateReportViewUri('/assets', {
                      page: 1,
                      filters: [
                        { key: 'project', values: [...details.projects.map(prjc => prjc.id)] },
                      ],
                    })}
                    className={isLinkDisabled(details.assets.all)}
                  >
                    <Button variant="contained" color="primary" disabled={!details.assets.all}>
                      {t('general:actions.view_all_assets')}
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.rented_asset_plural')}</b>
              </td>
              <td className="layout-flex">
                <div>
                  <span>{details.assets.rented}</span>
                  <Link
                    to={NavigationService.formulateReportViewUri('/assets', {
                      page: 1,
                      filters: [
                        { key: 'project', values: [...details.projects.map(prjc => prjc.id)] },
                        { key: 'asset_type', values: ['Rented Open'] },
                      ],
                    })}
                    className={isLinkDisabled(details.assets.rented)}
                  >
                    <Button variant="contained" color="primary" disabled={!details.assets.rented}>
                      {t('general:actions.view_asset', {
                        count: details.assets.rented,
                      })}
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.owned_asset_plural')}</b>
              </td>
              <td className="layout-flex">
                <div>
                  <span>{details.assets.owned}</span>
                  <Link
                    to={NavigationService.formulateReportViewUri('/assets', {
                      page: 1,
                      filters: [
                        { key: 'project', values: [...details.projects.map(prjc => prjc.id)] },
                        { key: 'asset_type', values: ['Owned'] },
                      ],
                    })}
                    className={isLinkDisabled(details.assets.owned)}
                  >
                    <Button variant="contained" color="primary" disabled={!details.assets.owned}>
                      {t('general:actions.view_asset', {
                        count: details.assets.owned,
                      })}
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}
